const ENV_SERVER_URL = {
    test: 'https://test.feia-apps.com/api',
    stage: 'https://stage.feia-apps.com/api',
    prod: 'https://live.feia-apps.com/api',
};

const ENV_APP_URL = {
    test: {
        bg: 'https://feia-v2-test.web.app',
        en: 'https://feia-en-test.web.app',
        de: 'https://feia-de-test.web.app',
        es: 'https://feia-es-test.web.app'
    },
    stage: {
        bg: 'https://feia-v2-stage.web.app',
        en: 'https://feia-en-stage.web.app',
        de: 'https://feia-de-stage.web.app',
        es: 'https://feia-es-stage.web.app'
    },
    prod: {
        // bg: 'https://feia-apps.com',
        bg: 'https://feia.bg',
        en: 'https://gaia-apps.eu',
        de: 'https://gaia-apps.at',
        es: 'https://gaia-apps.es'
    }

};

export const SERVER_URL =
    process.env.NODE_ENV === 'development'
        ? ENV_SERVER_URL.test
        : ENV_SERVER_URL[process.env.REACT_APP_ENV];

const ENV_FUNCTION_URL = {
    test: 'https://europe-west4-feia-v2-test.cloudfunctions.net/api',
    stage: 'https://europe-west4-feia-v2-stage.cloudfunctions.net/api',
    prod: 'https://europe-west4-feia-v2.cloudfunctions.net/api'
}

export const FUNCTIONS_URL =
    process.env.NODE_ENV === 'development'
        ? ENV_FUNCTION_URL.test
        : ENV_FUNCTION_URL[process.env.REACT_APP_ENV];

/**
 * @typedef {Object} EnvAppUrl
 * @property {string} bg - The URL for the 'bg' environment.
 * @property {string} en - The URL for the 'en' environment.
 */

/**
 * @type {EnvAppUrl}
 */
export const APP_URL =
    process.env.NODE_ENV === 'development'
        ? ENV_APP_URL.test
        : ENV_APP_URL[process.env.REACT_APP_ENV];
